export enum SettingsEndpoints {
  ROOT = '/settings',
}

export const staticSettingsEndpoints = {
  GET_GENERAL_SETTINGS: SettingsEndpoints.ROOT,
  UPDATE_GENERAL_SETTINGS: SettingsEndpoints.ROOT,
};

export interface IGeneralSettings {
  organization?: string;
  support_email?: string;
  support_phone_number?: string;
}

// ----------------- DTOs ----------------

export type TUpdateGeneralSettingsDTO = IGeneralSettings;

// ------------ Responses --------------

export type TGetGeneralSettingsResponse = IGeneralSettings;

export type IUpdateGeneralSettingsResponse = IGeneralSettings;
